// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"2b3ed99a529fdc5735f8","678":"950f181934e05a4fc8c0"}[chunkId] + ".js";
};